// Fenêtre de parrainage : jamais deux fois à la même personne dans la même semaine.
const KEY = "revanche_ref_popup_last";
const WEEK = 7 * 24 * 3600 * 1000;

export const canShowReferral = () => {
    try {
        const last = parseInt(localStorage.getItem(KEY) || "0", 10);
        return Date.now() - last > WEEK;
    } catch (e) { return true; }
};

export const markReferralShown = () => {
    try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
};
